function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20046460_140669)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 10,
  fill: "black"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_20046460_140669)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 32,
  cy: 31.9128,
  rx: 32,
  ry: 31.9128,
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.5 50L39.1286 38.4286H49.7143V34.0571H15V38.4286H25.5857L18.2143 50H23.7L32.3571 36.4143L41.0143 50H46.5ZM49.7143 29.8143V25.4429H39.3429L46.6286 14H41.1L32.3571 27.8L23.6143 14H18.0857L25.3714 25.4429H15V29.8571L49.7143 29.8143Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20046460_140669"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 10,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_20046460_140669"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 10,
  fill: "white"
})));
function SvgHiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiro);
export default __webpack_public_path__ + "static/media/hiro.d1067257d2a494a1421982dc4f3f8d0e.svg";
export { ForwardRef as ReactComponent };